import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'sun';
  size?: 'lg' | 'md';
  fullWidth?: boolean;
};
export function CTAButton({
  href,
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false
}: CTAButtonProps) {
  const color = variant === 'sun' ? 'bg-sun text-ink hover:bg-[#ffd664] shadow-[0_10px_30px_-10px_rgba(255,200,61,0.6)]' : 'bg-brand text-ink hover:bg-[#45e07f] shadow-[0_10px_30px_-10px_rgba(43,212,107,0.7)]';
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl' : 'px-6 py-4 text-base sm:text-lg';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-2xl font-black uppercase tracking-wide transition-[transform,background-color] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${color} ${sizing} ${fullWidth ? 'w-full' : ''}`} data-id="element-68" data-mp="33r8rn50vc9n0">
      <span data-id="element-69" data-mp="199of2gvjr9ta">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-70" data-mp="19ahcgr8m8myr" />
    </a>;
}